module.exports = "<div class=\"form-component\">\r\n  <span class=\"fa fa-image\"> </span>\r\n</div>\r\n"


//////////////////
// WEBPACK FOOTER
// D:/a/1/s/BackOffice/SOC/SxSoc.ClientWeb/src/app/private/sxfdesigner/components/designers/layout/files-manager/imageDesigner.component.html
// module id = ../../../../../src/app/private/sxfdesigner/components/designers/layout/files-manager/imageDesigner.component.html
// module chunks = main